export const signIn_type = "SIGN_IN";
export const signInSuccess_type = "SIGN_IN_SUCCESS";
export const profileImageUploadSuccess_type = "PROFILE_IMAGE_UPLOAD_SUCCESS";
export const signInFailed_type = "SIGN_IN_FAILED";

export const signOut_type = "SIGN_OUT";
